import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import type { Session } from "../types/session.ts";
import { handleSignInCallback, consumeReturnPath } from "../api/auth.ts";
import { useAuth } from "./authContext.tsx";

export function AuthCallback() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    handleSignInCallback()
      .then(async (session: Session) => {
        await login(session);
        const returnPath = consumeReturnPath();
        navigate(returnPath, { replace: true });
      })
      .catch((err: unknown) => {
        const message = err instanceof Error ? err.message : "Unknown error";
        setError(message);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return (
      <div>
        <p>Sign-in failed: {error}</p>
        <a href="/">Try again</a>
      </div>
    );
  }

  return <div>Completing sign-in...</div>;
}
